import {productService} from '@/assets/js/http'

/**
 * 隐私协议
 */
export function protocolAPI() {
    return productService({
        url:'api/agreements',
        method: 'get'
    })
}